import { Pipe, PipeTransform } from '@angular/core';
import { first, trim } from 'lodash';

@Pipe({
  name: 'formatToAvatar',
})
export class FormatToAvatarPipe implements PipeTransform {
  transform(firstName = '', lastName = '', upperCase = false): string {
    let result = (first(trim(firstName || '')) || '') + (first(trim(lastName || '')) || '');

    if (upperCase && result) result = result.toUpperCase();
    return result || ' ';
  }
}
